import { useSelector } from 'react-redux';
import { Routes, Route } from 'react-router-dom';
import styled from 'styled-components';
import Breadcrumb from './components/breadcrumb/Breadcrumb';
import ModuleLoader from './components/Loader/ModuleLoader';
import RouteManager from './components/Loader/RouteManager';
import { routePath } from '../routing/helpers/router';
import ModuleSelectScreen from '../screens/Home/ModuleSelectScreen';
import ChatBot from './screenSpecifics/Modules/LegalCompliance/Evaluation/ChatBot/ChatBot';
import ChangePasswordScreen from '../screens/Home/ChangePasswordScreen';
import UserQueryListScreen from '../screens/Home/UserQuery/UserQueryListScreen';
import UserQueryMessagesScreen from '../screens/Home/UserQuery/UserQueryMessagesScreen';
import LegalCompliancePlantSelectHomeScreen from '../screens/Modules/LegalCompliance/LegalCompliancePlantSelectHomeScreen';
import LegalComplianceEvaluationScreen from '../screens/Modules/LegalCompliance/LegalComplianceEvaluationScreen';
import LegalComplianceCalendarScreen from '../screens/Modules/LegalCompliance/LegalComplianceCalendarScreen';
import LegalComplianceModuleConfigurationScreen from '../screens/Modules/LegalCompliance/LegalComplianceModuleConfigurationScreen';
import LegalCompliancePendingEmailsScreen from '../screens/Modules/LegalCompliance/LegalCompliancePendingEmailsScreen';
import LegalCompliancePlantObligationFormMakeScreen from '../screens/Modules/LegalCompliance/ObligationForm/LegalCompliancePlantObligationFormMakeScreen';
import LegalCompliancePlantInformationScreen from '../screens/Modules/LegalCompliance/LegalCompliancePlantInformationScreen';
import LegalCompliancePlantConfigurationScreen from '../screens/Modules/LegalCompliance/LegalCompliancePlantConfigurationScreen';
import LegalCompliancePlantObligationFormManageScreen from '../screens/Modules/LegalCompliance/ObligationForm/LegalCompliancePlantObligationFormManageScreen';
import LegalComplianceInternalObligationScreen from '../screens/Modules/LegalCompliance/LegalComplianceInternalObligationScreen';
import LegalComplianceEvidencesScreen from '../screens/Modules/LegalCompliance/LegalComplianceEvidencesScreen';
import GlobalLegalComplianceEvaluationScreen from '../screens/Modules/GlobalLegalCompliance/GlobalLegalComplianceEvaluationScreen';
import GlobalLegalComplianceCalendarScreen from '../screens/Modules/GlobalLegalCompliance/GlobalLegalComplianceCalendarScreen';
import UserManagementHomeScreen from '../screens/Modules/UserManagement/UserManagementHomeScreen';
import UserManagementInfoScreen from '../screens/Modules/UserManagement/UserManagementInfoScreen';
import UserManagementAddScreen from '../screens/Modules/UserManagement/UserManagementAddScreen';
import UserManagementEditScreen from '../screens/Modules/UserManagement/UserManagementEditScreen';
import IntelligenceHomeScreen from '../screens/Modules/Intelligence/IntelligenceHomeScreen';
import IntelligenceStoredReportsScreen from '../screens/Modules/Intelligence/IntelligenceStoredReportsScreen';
import ModuleSaicaReportHomeScreen from '../screens/Modules/SaicaReports/Home/ModuleSaicaReportHomeScreen';
import ModuleSaicaReportReportScreen from '../screens/Modules/SaicaReports/Home/ModuleSaicaReportReportScreen';
import ModuleNewsletterManagerHomeScreen from '../screens/Modules/NewsletterManager/ModuleNewsletterManagerHomeScreen';
import ModuleChemicalTradingProductListScreen from '../screens/Modules/ChemicalTrading/ModuleChemicalTradingProductListScreen';
import ModuleChemicalTradingProductEditScreen from '../screens/Modules/ChemicalTrading/ModuleChemicalTradingProductEditScreen';
import ModuleChemicalTradingProductHomeScreen from '../screens/Modules/ChemicalTrading/ModuleChemicalTradingProductHomeScreen';
import ModuleChemicalTradingHomeScreen from '../screens/Modules/ChemicalTrading/ModuleChemicalTradingHomeScreen';
import ModuleChemicalTradingProductNewScreen from '../screens/Modules/ChemicalTrading/ModuleChemicalTradingProductNewScreen';
import ModuleLawFinderHomeScreen from '../screens/Modules/LawFinder/ModuleLawFinderHomeScreen';
import CorrectiveActionsTaskListScreen from '../screens/Modules/CorrectiveActions/CorrectiveActionsTaskListScreen';
import CorrectiveActionsTaskEditScreen from '../screens/Modules/CorrectiveActions/CorrectiveActionsTaskEditScreen';
import CorrectiveActionsTaskAddScreen from '../screens/Modules/CorrectiveActions/CorrectiveActionsTaskAddScreen';
import ModuleComsaEnvironmentalHomeScreen from '../screens/Modules/ComsaEnvironmental/ModuleComsaEnvironmentalHomeScreen';
import ModuleComsaEnvironmentalIndustrialDataInputScreen from '../screens/Modules/ComsaEnvironmental/ModuleComsaEnvironmentalIndustrial/ModuleComsaEnvironmentalIndustrialDataInputScreen';
import ModuleComsaEnvironmentalOfficeNormalEnvironmentalAspectsScreen from '../screens/Modules/ComsaEnvironmental/ModuleComsaEnvironmentalOffice/ModuleComsaEnvironmentalOfficeNormalEnvironmentalAspectsScreen';
import ModuleComsaEnvironmentalOfficeEmergencyAndPotentialEnvironmentalAspectsScreen from '../screens/Modules/ComsaEnvironmental/ModuleComsaEnvironmentalOffice/ModuleComsaEnvironmentalOfficeEmergencyAndPotentialEnvironmentalAspectsScreen';
import ModuleComsaEnvironmentalOfficeChangesManagementScreen from '../screens/Modules/ComsaEnvironmental/ModuleComsaEnvironmentalOffice/ModuleComsaEnvironmentalOfficeChangesManagementScreen';
import ModuleComsaEnvironmentalOfficeNotesAndObservationsScreen from '../screens/Modules/ComsaEnvironmental/ModuleComsaEnvironmentalOffice/ModuleComsaEnvironmentalOfficeNotesAndObservationsScreen';
import ModuleComsaEnvironmentalConstructionNormalAspectsScreen from '../screens/Modules/ComsaEnvironmental/ModuleComsaEnvironmentalConstruction/ModuleComsaEnvironmentalConstructionNormalAspectsScreen';
import ModuleComsaEnvironmentalConstructionDataInputScreen from '../screens/Modules/ComsaEnvironmental/ModuleComsaEnvironmentalConstruction/ModuleComsaEnvironmentalConstructionDataInputScreen';
import ModuleComsaEnvironmentalConstructionEmergencyPotentialsAspectsScreen from '../screens/Modules/ComsaEnvironmental/ModuleComsaEnvironmentalConstruction/ModuleComsaEnvironmentalConstructionEmergencyPotentialsAspectsScreen';
import ModuleComsaEnvironmentalConstructionDesignScreen from '../screens/Modules/ComsaEnvironmental/ModuleComsaEnvironmentalConstruction/ModuleComsaEnvironmentalConstructionDesignScreen';
import ModuleComsaEnvironmentalConstructionDesignNormalAspectsScreen from '../screens/Modules/ComsaEnvironmental/ModuleComsaEnvironmentalConstruction/ModuleComsaEnvironmentalConstructionDesignNormalAspectsScreen';
import ModuleComsaEnvironmentalConstructionPpiScreen from '../screens/Modules/ComsaEnvironmental/ModuleComsaEnvironmentalConstruction/ModuleComsaEnvironmentalConstructionPpiScreen';
import ModuleComsaEnvironmentalConstructionControlCardScreen from '../screens/Modules/ComsaEnvironmental/ModuleComsaEnvironmentalConstruction/ModuleComsaEnvironmentalConstructionControlCardScreen';
import ModuleComsaEnvironmentalConstructionUseNormalAspectsScreen from '../screens/Modules/ComsaEnvironmental/ModuleComsaEnvironmentalConstruction/ModuleComsaEnvironmentalConstructionUseNormalAspectsScreen';
import ModuleComsaEnvironmentalConstructionDeconstructionNormalAspectsScreen from '../screens/Modules/ComsaEnvironmental/ModuleComsaEnvironmentalConstruction/ModuleComsaEnvironmentalConstructionDeconstructionNormalAspectsScreen';
import ModuleComsaEnvironmentalIndustrialNormalAspectsScreen from '../screens/Modules/ComsaEnvironmental/ModuleComsaEnvironmentalIndustrial/ModuleComsaEnvironmentalIndustrialNormalAspectsScreen';
import ModuleComsaEnvironmentalIndustrialPpiScreen from '../screens/Modules/ComsaEnvironmental/ModuleComsaEnvironmentalIndustrial/ModuleComsaEnvironmentalIndustrialPpiScreen';
import ModuleComsaEnvironmentalIndustrialControlCardScreen from '../screens/Modules/ComsaEnvironmental/ModuleComsaEnvironmentalIndustrial/ModuleComsaEnvironmentalIndustrialControlCardScreen';
import ModuleComsaEnvironmentalIndustrialDesignNormalAspectsScreen from '../screens/Modules/ComsaEnvironmental/ModuleComsaEnvironmentalIndustrial/ModuleComsaEnvironmentalIndustrialDesignNormalAspectsScreen';
import ModuleComsaEnvironmentalIndustrialEmergencyPotentialsAspectsScreen from '../screens/Modules/ComsaEnvironmental/ModuleComsaEnvironmentalIndustrial/ModuleComsaEnvironmentalIndustrialEmergencyPotentialsAspectsScreen';
import ModuleComsaEnvironmentalIndustrialUseNormalAspectsScreen from '../screens/Modules/ComsaEnvironmental/ModuleComsaEnvironmentalIndustrial/ModuleComsaEnvironmentalIndustrialUseNormalAspectsScreen';
import ModuleComsaEnvironmentalIndustrialDeconstructionNormalAspectsScreen from '../screens/Modules/ComsaEnvironmental/ModuleComsaEnvironmentalIndustrial/ModuleComsaEnvironmentalIndustrialDeconstructionNormalAspectsScreen';
import ModuleResourceManagerResourceHomeScreen from '../screens/Modules/ResourceManager/ModuleResourceManagerResourceHomeScreen';
import ModuleResourceManagerObligationHomeScreen from '../screens/Modules/ResourceManager/ModuleResourceManagerObligationHomeScreen';
import ModuleResourceManagerCalendarScreen from '../screens/Modules/ResourceManager/ModuleResourceManagerCalendarScreen';
import ModuleResourceManagerSettingsResourceTemplateListScreen from '../screens/Modules/ResourceManager/ModuleResourceManagerResourceTemplate/ModuleResourceManagerSettingsResourceTemplateListScreen';
import ModuleResourceManagerSettingsResourceAddScreen from '../screens/Modules/ResourceManager/ModuleResourceManagerResourceTemplate/ModuleResourceManagerSettingsResourceAddScreen';
import ModuleResourceManagerSettingsResourceTemplateCloneScreen from '../screens/Modules/ResourceManager/ModuleResourceManagerResourceTemplate/ModuleResourceManagerSettingsResourceTemplateCloneScreen';
import ModuleResourceManagerSettingsInternalObligationsScreen from '../screens/Modules/ResourceManager/ModuleResourceManagerSettingsInternalObligationsScreen';
import ModuleResourceManagerSettingsInternalObligationHomeScreen from '../screens/Modules/ResourceManager/ModuleResourceManagerSettingsInternalObligationHomeScreen';
import ModuleInecoRiskManagerRiskListScreen from '../screens/Modules/InecoRiskManager/ModuleInecoRiskManagerRiskListScreen';
import ModuleInecoRiskManagerRiskHomeScreen from '../screens/Modules/InecoRiskManager/ModuleInecoRiskManagerRiskHomeScreen';
import ModuleInecoRiskManagerMilestoneScreen from '../screens/Modules/InecoRiskManager/ModuleInecoRiskManagerMilestoneScreen';
import ModuleDocumentManagerItemListScreen from '../screens/Modules/DocumentManager/ModuleDocumentManagerItemListScreen';
import ModuleDocumentManagerPendingItemListScreen from '../screens/Modules/DocumentManager/ModuleDocumentManagerPendingItemListScreen';
import ModuleDocumentManagerTagListScreen from '../screens/Modules/DocumentManager/ModuleDocumentManagerTagListScreen';
import ModuleDocumentManagerLogListScreen from '../screens/Modules/DocumentManager/ModuleDocumentManagerLogListScreen';
import ModuleDocumentManagerCoverScreen from '../screens/Modules/DocumentManager/ModuleDocumentManagerCoverScreen';
import ModuleTotalEnergiesRiskRiskListScreen from '../screens/Modules/TotalEnergiesRisk/ModuleTotalEnergiesRiskRiskListScreen';
import ModuleTotalEnergiesRiskRiskHomeScreen from '../screens/Modules/TotalEnergiesRisk/ModuleTotalEnergiesRiskRiskHomeScreen';
import ModuleTotalEnergiesRiskControlListScreen from '../screens/Modules/TotalEnergiesRisk/ModuleTotalEnergiesRiskControlListScreen';
import ModuleTotalEnergiesRiskControlHomeScreen from '../screens/Modules/TotalEnergiesRisk/ModuleTotalEnergiesRiskControlHomeScreen';
import ModuleTotalEnergiesRiskControlReviewHomeScreen from '../screens/Modules/TotalEnergiesRisk/ModuleTotalEnergiesRiskControlReviewHomeScreen';
import ModuleTotalEnergiesRiskActionPlanListScreen from '../screens/Modules/TotalEnergiesRisk/ModuleTotalEnergiesRiskActionPlanListScreen';
import ModuleTotalEnergiesRiskActionPlanHomeScreen from '../screens/Modules/TotalEnergiesRisk/ModuleTotalEnergiesRiskActionPlanHomeScreen';
import ModuleTotalEnergiesRiskActionPlanReviewHomeScreen from '../screens/Modules/TotalEnergiesRisk/ModuleTotalEnergiesRiskActionPlanReviewHomeScreen';
import ModuleTotalEnergiesRiskProcessListScreen from '../screens/Modules/TotalEnergiesRisk/ModuleTotalEnergiesRiskProcessListScreen';
import ModuleTotalEnergiesRiskLogListScreen from '../screens/Modules/TotalEnergiesRisk/ModuleTotalEnergiesRiskLogListScreen';
import EnvironmentalAspectsAssessmentAssessmentCurrentScreen from '../screens/Modules/EnvironmentalAspectsAssessment/EnvironmentalAspectsAssessmentAssessmentCurrentScreen';
import EnvironmentalAspectsAssessmentAssessmentHomeScreen from '../screens/Modules/EnvironmentalAspectsAssessment/EnvironmentalAspectsAssessmentAssessmentHomeScreen';
import EnvironmentalAspectsAssessmentAspectLogListScreen from '../screens/Modules/EnvironmentalAspectsAssessment/EnvironmentalAspectsAssessmentAspectLogListScreen';
import EnvironmentalAspectsAssessmentInspectionListScreen from '../screens/Modules/EnvironmentalAspectsAssessment/EnvironmentalAspectsAssessmentInspectionListScreen';
import ModuleBridgeFolderHomeScreen from '../screens/Modules/ModuleBridgeFolder/ModuleBridgeFolderHomeScreen';
import ModuleComsaReportHomeScreen from '@/screens/Modules/ComsaReports/ModuleComsaReportHomeScreen';
import ModuleComsaPowerUseReportScreen from '@/screens/Modules/ComsaReports/ModuleComsaPowerUseReportScreen';
import ModuleComsaFuelUseReportScreen from '@/screens/Modules/ComsaReports/ModuleComsaFuelUseReportScreen';
import ModuleComsaWaterUseReportScreen from '@/screens/Modules/ComsaReports/ModuleComsaWaterUseReportScreen';
import ModuleComsaPaperUseReportScreen from '@/screens/Modules/ComsaReports/ModuleComsaPaperUseReportScreen';
import ModuleComsaNaturalGasUseReportScreen from '@/screens/Modules/ComsaReports/ModuleComsaNaturalGasUseReportScreen';
import ModuleComsaCoolingGasUseReportScreen from '@/screens/Modules/ComsaReports/ModuleComsaCoolingGasUseReportScreen';
import ModuleComsaWaterWasteReportScreen from '@/screens/Modules/ComsaReports/ModuleComsaWaterWasteReportScreen';
import ModuleComsaWasteManagementReportScreen from '../screens/Modules/ComsaReports/ModuleComsaWasteManagementReportScreen';
import ModuleComsaNaturalResourcesUseReductionReportScreen from '@/screens/Modules/ComsaReports/ModuleComsaNaturalResourcesUseReductionReportScreen';
import ModuleComsaLandscapeRestorationScreen from '@/screens/Modules/ComsaReports/ModuleComsaLandscapeRestorationScreen';
import ModuleComsaEnergyEfficiencyScreen from '@/screens/Modules/ComsaReports/ModuleComsaEnergyEfficiencyScreen';
import ModuleComsaWasteRecoveryScreen from '@/screens/Modules/ComsaReports/ModuleComsaWasteRecoveryScreen';
import ModuleComsaCarbonFootprintScreen from '@/screens/Modules/ComsaReports/ModuleComsaCarbonFootprintScreen';
import ModuleComsaRecycledPackagingMaterialScreen from '@/screens/Modules/ComsaReports/ModuleComsaRecycledPackagingMaterialScreen';
import ModuleComsaTertiaryPackagingScreen from '@/screens/Modules/ComsaReports/ModuleComsaTertiaryPackagingScreen';
import ModuleComsaFoodWasteScreen from '@/screens/Modules/ComsaReports/ModuleComsaFoodWasteScreen';
import ModuleComsaEnergyCertificateScreen from '@/screens/Modules/ComsaReports/ModuleComsaEnergyCertificateScreen';
import ModuleComsaElectricChargerScreen from '@/screens/Modules/ComsaReports/ModuleComsaElectricChargerScreen';
import ModuleComsaGoodLogisticsPracticesScreen from '@/screens/Modules/ComsaReports/ModuleComsaGoodLogisticsPracticesScreen';
import ModuleQseReportHomeScreen from '@/screens/Modules/QseReports/ModuleQseReportHomeScreen';
import ModuleQseReportScreen from '@/screens/Modules/QseReports/ModuleQseReportScreen';
import CommunicationPipelineHomeScreen from '@/screens/Modules/CommunicationPipeline/CommunicationPipelineHomeScreen';
import CommunicationPipelineUserReportStatusScreen from '@/screens/Modules/CommunicationPipeline/User/CommunicationPipelineUserReportStatusScreen';
import CommunicationPipelineUserReportSentScreen from '@/screens/Modules/CommunicationPipeline/User/CommunicationPipelineUserReportSentScreen';
import CommunicationPipelineUserReportThreadScreen from '@/screens/Modules/CommunicationPipeline/User/CommunicationPipelineUserReportThreadScreen';
import CommunicationPipelineUserReportCommunicationScreen from '@/screens/Modules/CommunicationPipeline/User/CommunicationPipelineUserReportCommunicationScreen';
import CommunicationPipelineUserReportAddScreen from '@/screens/Modules/CommunicationPipeline/User/CommunicationPipelineUserReportAddScreen';
import CommunicationPipelineUserInquiryAddScreen from '@/screens/Modules/CommunicationPipeline/User/CommunicationPipelineUserInquiryAddScreen';
import CommunicationPipelineUserInquiryCommunicationScreen from '@/screens/Modules/CommunicationPipeline/User/CommunicationPipelineUserInquiryCommunicationScreen';
import CommunicationPipelineAdminReportStatusScreen from '@/screens/Modules/CommunicationPipeline/Admin/CommunicationPipelineAdminReportStatusScreen';
import CommunicationPipelineAdminReportSentScreen from '@/screens/Modules/CommunicationPipeline/Admin/CommunicationPipelineAdminReportSentScreen';
import CommunicationPipelineAdminReportSignScreen from '@/screens/Modules/CommunicationPipeline/Admin/CommunicationPipelineAdminReportSignScreen';
import CommunicationPipelineAdminReportProcessingScreen from '@/screens/Modules/CommunicationPipeline/Admin/CommunicationPipelineAdminReportProcessingScreen';
import CommunicationPipelineAdminReportSubjectToAppealScreen from '@/screens/Modules/CommunicationPipeline/Admin/CommunicationPipelineAdminReportSubjectToAppealScreen';
import CommunicationPipelineAdminReportAllegationsScreen from '@/screens/Modules/CommunicationPipeline/Admin/CommunicationPipelineAdminReportAllegationsScreen';
import CommunicationPipelineAdminReportEndScreen from '@/screens/Modules/CommunicationPipeline/Admin/CommunicationPipelineAdminReportEndScreen';
import CommunicationPipelineAdminReportThreadScreen from '@/screens/Modules/CommunicationPipeline/Admin/CommunicationPipelineAdminReportThreadScreen';
import CommunicationPipelineAdminReportCommunicationScreen from '@/screens/Modules/CommunicationPipeline/Admin/CommunicationPipelineAdminReportCommunicationScreen';
import CommunicationPipelineInquiryListScreen from '@/screens/Modules/CommunicationPipeline/Admin/CommunicationPipelineInquiryListScreen';
import CommunicationPipelineAdminInquiryCommunicationScreen from '@/screens/Modules/CommunicationPipeline/Admin/CommunicationPipelineAdminInquiryCommunicationScreen';
import NotFoundScreen from '@/screens/Error/NotFoundScreen';
import ModuleDocumentManagerCoverRedirectScreen from '../screens/Modules/DocumentManager/ModuleDocumentManagerCoverRedirectScreen';
import ModuleComsaOccupationScreen from '@/screens/Modules/ComsaReports/ModuleComsaOccupationScreen';
import ModuleComsaRecycledPaperScreen from '@/screens/Modules/ComsaReports/ModuleComsaRecycledPaperScreen';
import ModuleComsaNonRecycledPaperScreen from '@/screens/Modules/ComsaReports/ModuleComsaNonRecycledPaperScreen';
import EnvironmentalAspectsAssessmentInspectionHomeScreen from '../screens/Modules/EnvironmentalAspectsAssessment/EnvironmentalAspectsAssessmentInspectionHomeScreen';
import ModuleComsaBiodiversityScreen from '@/screens/Modules/ComsaReports/ModuleComsaBiodiversityScreen';
import AdvancedSearchHomeScreen from '../screens/Modules/AdvancedSearch/AdvancedSearchHomeScreen';
import SurveyHomeScreen from '../screens/Modules/Survey/SurveyHomeScreen';
import DynamicFormHomeScreen from '../screens/Modules/DynamicForm/DynamicFormHomeScreen';
import ModuleDynamicFormStepScreen from '@/screens/Modules/DynamicForm/ModuleDynamicFormStepScreen';
import ModuleDynamicFormEndConfirmScreen from '@/screens/Modules/DynamicForm/ModuleDynamicFormEndConfirmScreen';
import ModuleDynamicFormEndScreen from '@/screens/Modules/DynamicForm/ModuleDynamicFormEndScreen';

const MainContainer = () => {
  const isSidebarOpened = useSelector(
    (state) => state.auth?.settings?.preferences?.sidebar?.isOpened,
  );
  const isSidebar = useSelector((state) => state.global.isSidebar);
  const permissions = useSelector((state) => state.global.permissions);

  return (
    <Container $expanded={isSidebarOpened && isSidebar} $noSidebar={isSidebar}>
      <div className="justify-content-between flex-wrap flex-md-nowrap align-items-center pt-1 pb-0 mb-0">
        <Breadcrumb />
        <ModuleLoader />

        {permissions?.global?.chatBot && <ChatBot />}
        <Routes>
          {/* BASE */}
          <Route path={''} element={<RouteManager />}>
            <Route
              path={routePath('user_home')}
              exact
              element={<ModuleSelectScreen />}
            />
            {/* CHANGE PASSWORD */}
            <Route
              path={routePath('user_change_password')}
              exact
              element={<ChangePasswordScreen />}
            />

            {/* MODULE - INTELLIGENCE */}
            <Route
              path={routePath('user_module_intelligence_home')}
              exact
              element={<IntelligenceHomeScreen />}
            />
            <Route
              path={routePath('user_module_intelligence_storedReports')}
              exact
              element={<IntelligenceStoredReportsScreen />}
            />

            {/* MODULE - SAICA REPORT */}
            <Route
              path={routePath('user_module_saicaReport_home')}
              exact
              element={<ModuleSaicaReportHomeScreen />}
            />
            <Route
              path={routePath('user_module_saicaReport_report')}
              exact
              element={<ModuleSaicaReportReportScreen />}
            />

            {/* SUBMODULE - COMSA REPORTS */}
            <Route
              path={routePath('user_module_comsaReports_home')}
              element={<ModuleComsaReportHomeScreen />}
            />
            <Route
              path={routePath('user_module_comsaReports_power_use')}
              element={<ModuleComsaPowerUseReportScreen />}
            />
            <Route
              path={routePath('user_module_comsaReports_fuel_use')}
              element={<ModuleComsaFuelUseReportScreen />}
            />
            <Route
              path={routePath('user_module_comsaReports_water_use')}
              element={<ModuleComsaWaterUseReportScreen />}
            />
            <Route
              path={routePath('user_module_comsaReports_paper_use')}
              element={<ModuleComsaPaperUseReportScreen />}
            />
            <Route
              path={routePath('user_module_comsaReports_natural_gas_use')}
              element={<ModuleComsaNaturalGasUseReportScreen />}
            />
            <Route
              path={routePath('user_module_comsaReports_cooling_gas_use')}
              element={<ModuleComsaCoolingGasUseReportScreen />}
            />
            <Route
              path={routePath('user_module_comsaReports_water_waste')}
              element={<ModuleComsaWaterWasteReportScreen />}
            />
            <Route
              path={routePath('user_module_comsaReports_waste_management')}
              element={<ModuleComsaWasteManagementReportScreen />}
            />
            <Route
              path={routePath(
                'user_module_comsaReports_natural_resources_use_reduction',
              )}
              element={<ModuleComsaNaturalResourcesUseReductionReportScreen />}
            />
            <Route
              path={routePath('user_module_comsaReports_landscape_restoration')}
              element={<ModuleComsaLandscapeRestorationScreen />}
            />
            <Route
              path={routePath('user_module_comsaReports_energy_efficiency')}
              element={<ModuleComsaEnergyEfficiencyScreen />}
            />
            <Route
              path={routePath('user_module_comsaReports_waste_recovery')}
              element={<ModuleComsaWasteRecoveryScreen />}
            />
            <Route
              path={routePath('user_module_comsaReports_carbon_footprint')}
              element={<ModuleComsaCarbonFootprintScreen />}
            />
            <Route
              path={routePath('user_module_comsaReports_recycled_packaging_material')}
              element={<ModuleComsaRecycledPackagingMaterialScreen />}
            />
            <Route
              path={routePath('user_module_comsaReports_tertiary_packaging')}
              element={<ModuleComsaTertiaryPackagingScreen />}
            />
            <Route
              path={routePath('user_module_comsaReports_food_waste')}
              element={<ModuleComsaFoodWasteScreen />}
            />
            <Route
              path={routePath('user_module_comsaReports_energy_certificate')}
              element={<ModuleComsaEnergyCertificateScreen />}
            />
            <Route
              path={routePath('user_module_comsaReports_electric_charger')}
              element={<ModuleComsaElectricChargerScreen />}
            />
            <Route
              path={routePath('user_module_comsaReports_goodLogisticsPractices')}
              element={<ModuleComsaGoodLogisticsPracticesScreen />}
            />
            <Route
              path={routePath('user_module_comsaReports_occupation')}
              element={<ModuleComsaOccupationScreen />}
            />
            <Route
              path={routePath('user_module_comsaReports_recycledPaper')}
              element={<ModuleComsaRecycledPaperScreen />}
            />
            <Route
              path={routePath('user_module_comsaReports_nonRecycledPaper')}
              element={<ModuleComsaNonRecycledPaperScreen />}
            />
            <Route
              path={routePath('user_module_comsaReports_biodiversity')}
              element={<ModuleComsaBiodiversityScreen />}
            />

            {/* INFO REQUEST */}
            <Route
              path={routePath('user_module_legalCompliance_userQuery_list')}
              exact
              element={<UserQueryListScreen />}
            />
            <Route
              path={routePath('user_module_legalCompliance_userQuery_messages')}
              exact
              element={<UserQueryMessagesScreen />}
            />

            {/* MODULE - LEGAL COMPLIANCE */}
            <Route
              path={routePath('user_module_legalCompliance_home')}
              exact
              element={<LegalCompliancePlantSelectHomeScreen />}
            />
            <Route
              path={routePath('user_module_legalCompliance_evaluation')}
              exact
              element={<LegalComplianceEvaluationScreen />}
            />
            <Route
              path={routePath('user_module_legalCompliance_calendar')}
              exact
              element={<LegalComplianceCalendarScreen />}
            />
            <Route
              path={routePath('user_module_legalCompliance_configuration')}
              exact
              element={<LegalComplianceModuleConfigurationScreen />}
            />
            <Route
              path={routePath('user_module_legalCompliance_pendingEmails')}
              exact
              element={<LegalCompliancePendingEmailsScreen />}
            />
            <Route
              path={routePath('user_module_legalCompliance_plantObligationForm_edit')}
              exact
              element={<LegalCompliancePlantObligationFormMakeScreen />}
            />
            <Route
              path={routePath('user_module_legalCompliance_plantInformation')}
              exact
              element={<LegalCompliancePlantInformationScreen />}
            />
            <Route
              path={routePath('user_module_legalCompliance_plantConfiguration')}
              exact
              element={<LegalCompliancePlantConfigurationScreen />}
            />
            <Route
              path={routePath(
                'user_module_legalCompliance_plantObligationForm_manage',
              )}
              exact
              element={<LegalCompliancePlantObligationFormManageScreen />}
            />
            <Route
              path={routePath('user_module_legalCompliance_internalObligation')}
              exact
              element={<LegalComplianceInternalObligationScreen />}
            />
            <Route
              path={routePath('user_module_legalCompliance_evidences')}
              exact
              element={<LegalComplianceEvidencesScreen />}
            />

            {/* MODULE - GLOBAL LEGAL COMPLIANCE */}
            <Route
              path={routePath('user_module_globalLegalCompliance_evaluation')}
              exact
              element={<GlobalLegalComplianceEvaluationScreen />}
            />
            <Route
              path={routePath('user_module_globalLegalCompliance_calendar')}
              exact
              element={<GlobalLegalComplianceCalendarScreen />}
            />

            {/* MODULE - CORRECTIVE ACTIONS */}
            <Route
              path={routePath('user_module_correctiveActions_task_list')}
              exact
              element={<CorrectiveActionsTaskListScreen />}
            />
            <Route
              path={routePath('user_module_correctiveActions_task_add')}
              exact
              element={<CorrectiveActionsTaskAddScreen />}
            />
            <Route
              path={routePath('user_module_correctiveActions_task_edit')}
              exact
              element={<CorrectiveActionsTaskEditScreen />}
            />

            {/* MODULE - USER MANAGEMENT */}
            <Route
              path={routePath('user_module_userManagement_home')}
              exact
              element={<UserManagementHomeScreen />}
            />
            <Route
              path={routePath('user_module_userManagement_userInfo')}
              exact
              element={<UserManagementInfoScreen />}
            />
            <Route
              path={routePath('user_module_userManagement_add')}
              exact
              element={<UserManagementAddScreen />}
            />
            <Route
              path={routePath('user_module_userManagement_edit')}
              exact
              element={<UserManagementEditScreen />}
            />

            {/* MODULE - COMMUNICATION PIPELINE */}
            <Route
              path={routePath('user_module_communicationPipeline_home')}
              element={<CommunicationPipelineHomeScreen />}
            />
            <Route
              path={routePath('user_module_communicationPipeline_user_report_add')}
              element={<CommunicationPipelineUserReportAddScreen />}
            />
            <Route
              path={routePath('user_module_communicationPipeline_user_inquiry_add')}
              element={<CommunicationPipelineUserInquiryAddScreen />}
            />
            <Route
              path={routePath(
                'user_module_communicationPipeline_admin_report_status',
              )}
              element={<CommunicationPipelineAdminReportStatusScreen />} //
            />
            <Route
              path={routePath('user_module_communicationPipeline_admin_report_sent')}
              element={<CommunicationPipelineAdminReportSentScreen />}
            />
            <Route
              path={routePath('user_module_communicationPipeline_admin_report_sign')}
              element={<CommunicationPipelineAdminReportSignScreen />}
            />
            <Route
              path={routePath(
                'user_module_communicationPipeline_admin_report_processing',
              )}
              element={<CommunicationPipelineAdminReportProcessingScreen />}
            />
            <Route
              path={routePath(
                'user_module_communicationPipeline_admin_report_subjectToAppeal',
              )}
              element={<CommunicationPipelineAdminReportSubjectToAppealScreen />}
            />
            <Route
              path={routePath(
                'user_module_communicationPipeline_admin_report_allegations',
              )}
              element={<CommunicationPipelineAdminReportAllegationsScreen />}
            />
            <Route
              path={routePath('user_module_communicationPipeline_admin_report_end')}
              element={<CommunicationPipelineAdminReportEndScreen />}
            />
            <Route
              path={routePath(
                'user_module_communicationPipeline_admin_report_thread',
              )}
              element={<CommunicationPipelineAdminReportThreadScreen />}
            />
            <Route
              path={routePath(
                'user_module_communicationPipeline_admin_report_communication',
              )}
              element={<CommunicationPipelineAdminReportCommunicationScreen />}
            />
            <Route
              path={routePath('user_module_communicationPipeline_admin_inquiry_list')}
              element={<CommunicationPipelineInquiryListScreen />}
            />
            <Route
              path={routePath(
                'user_module_communicationPipeline_admin_inquiry_communication',
              )}
              element={<CommunicationPipelineAdminInquiryCommunicationScreen />}
            />
            <Route
              path={routePath('user_module_communicationPipeline_user_report_status')}
              element={<CommunicationPipelineUserReportStatusScreen />}
            />
            <Route
              path={routePath('user_module_communicationPipeline_user_report_sent')}
              element={<CommunicationPipelineUserReportSentScreen />}
            />
            <Route
              path={routePath('user_module_communicationPipeline_user_report_thread')}
              element={<CommunicationPipelineUserReportThreadScreen />}
            />
            <Route
              path={routePath(
                'user_module_communicationPipeline_user_report_communication',
              )}
              element={<CommunicationPipelineUserReportCommunicationScreen />}
            />
            <Route
              path={routePath(
                'user_module_communicationPipeline_user_inquiry_communication',
              )}
              element={<CommunicationPipelineUserInquiryCommunicationScreen />}
            />

            {/* SUBMODULE - COMSA Environmental */}
            <Route
              path={routePath('user_module_comsaEnvironmental_home')}
              element={<ModuleComsaEnvironmentalHomeScreen />}
            />
            <Route
              path={routePath(
                'user_module_comsaEnvironmental_office_normal_environmental_aspects',
              )}
              element={
                <ModuleComsaEnvironmentalOfficeNormalEnvironmentalAspectsScreen />
              }
            />
            <Route
              path={routePath(
                'user_module_comsaEnvironmental_office_emergency_and_potential_environmental_aspects',
              )}
              element={
                <ModuleComsaEnvironmentalOfficeEmergencyAndPotentialEnvironmentalAspectsScreen />
              }
            />
            <Route
              path={routePath(
                'user_module_comsaEnvironmental_office_changes_management',
              )}
              element={<ModuleComsaEnvironmentalOfficeChangesManagementScreen />}
            />
            <Route
              path={routePath(
                'user_module_comsaEnvironmental_office_notes_and_observations',
              )}
              element={<ModuleComsaEnvironmentalOfficeNotesAndObservationsScreen />}
            />
            <Route
              path={routePath(
                'user_module_comsaEnvironmental_construction_data_input',
              )}
              element={<ModuleComsaEnvironmentalConstructionDataInputScreen />}
            />
            <Route
              path={routePath('user_module_comsaEnvironmental_construction_design')}
              element={<ModuleComsaEnvironmentalConstructionDesignScreen />}
            />
            <Route
              path={routePath(
                'user_module_comsaEnvironmental_construction_design_normal_aspects',
              )}
              element={
                <ModuleComsaEnvironmentalConstructionDesignNormalAspectsScreen />
              }
            />
            <Route
              path={routePath(
                'user_module_comsaEnvironmental_construction_use_normal_aspects',
              )}
              element={<ModuleComsaEnvironmentalConstructionUseNormalAspectsScreen />}
            />
            <Route
              path={routePath(
                'user_module_comsaEnvironmental_construction_control_card',
              )}
              element={<ModuleComsaEnvironmentalConstructionControlCardScreen />}
            />
            <Route
              path={routePath(
                'user_module_comsaEnvironmental_construction_normal_aspects',
              )}
              element={<ModuleComsaEnvironmentalConstructionNormalAspectsScreen />}
            />
            <Route
              path={routePath(
                'user_module_comsaEnvironmental_construction_deconstruction_normal_aspects',
              )}
              element={
                <ModuleComsaEnvironmentalConstructionDeconstructionNormalAspectsScreen />
              }
            />
            <Route
              path={routePath(
                'user_module_comsaEnvironmental_construction_emergency_potentials_aspects',
              )}
              element={
                <ModuleComsaEnvironmentalConstructionEmergencyPotentialsAspectsScreen />
              }
            />
            <Route
              path={routePath('user_module_comsaEnvironmental_construction_ppi')}
              element={<ModuleComsaEnvironmentalConstructionPpiScreen />}
            />
            <Route
              path={routePath('user_module_comsaEnvironmental_industrial_data_input')}
              element={<ModuleComsaEnvironmentalIndustrialDataInputScreen />}
            />
            <Route
              path={routePath(
                'user_module_comsaEnvironmental_industrial_design_normal_aspects',
              )}
              element={
                <ModuleComsaEnvironmentalIndustrialDesignNormalAspectsScreen />
              }
            />
            <Route
              path={routePath(
                'user_module_comsaEnvironmental_industrial_use_normal_aspects',
              )}
              element={<ModuleComsaEnvironmentalIndustrialUseNormalAspectsScreen />}
            />
            <Route
              path={routePath(
                'user_module_comsaEnvironmental_industrial_control_card',
              )}
              element={<ModuleComsaEnvironmentalIndustrialControlCardScreen />}
            />
            <Route
              path={routePath(
                'user_module_comsaEnvironmental_industrial_normal_aspects',
              )}
              element={<ModuleComsaEnvironmentalIndustrialNormalAspectsScreen />}
            />
            <Route
              path={routePath(
                'user_module_comsaEnvironmental_industrial_deconstruction_normal_aspects',
              )}
              element={
                <ModuleComsaEnvironmentalIndustrialDeconstructionNormalAspectsScreen />
              }
            />
            <Route
              path={routePath(
                'user_module_comsaEnvironmental_industrial_emergency_potentials_aspects',
              )}
              element={
                <ModuleComsaEnvironmentalIndustrialEmergencyPotentialsAspectsScreen />
              }
            />
            <Route
              path={routePath('user_module_comsaEnvironmental_industrial_ppi')}
              element={<ModuleComsaEnvironmentalIndustrialPpiScreen />}
            />

            {/* SUBMODULE - QHSE Reports WIP - HAY QUE TESTEARLO */}
            <Route
              path={routePath('user_module_qseReports_home')}
              element={<ModuleQseReportHomeScreen />}
            />
            <Route
              path={routePath('user_module_qseReports_quality')}
              element={<ModuleQseReportScreen reportType="quality" />}
            />
            <Route
              path={routePath('user_module_qseReports_safety')}
              element={<ModuleQseReportScreen reportType="safety" />}
            />
            <Route
              path={routePath('user_module_qseReports_environment')}
              element={<ModuleQseReportScreen reportType="environment" />}
            />

            {/* MODULE - CHEMICAL TRADING */}
            <Route
              path={routePath('user_module_chemicalTrading_home')}
              element={<ModuleChemicalTradingHomeScreen />}
            />
            <Route
              path={routePath('user_module_chemicalTrading_product_list')}
              element={<ModuleChemicalTradingProductListScreen />}
            />
            <Route
              path={routePath('user_module_chemicalTrading_product_new')}
              element={<ModuleChemicalTradingProductNewScreen />}
            />
            <Route
              path={routePath('user_module_chemicalTrading_product_edit')}
              element={<ModuleChemicalTradingProductEditScreen />}
            />
            <Route
              path={routePath('user_module_chemicalTrading_product_home')}
              element={<ModuleChemicalTradingProductHomeScreen />}
            />

            {/* MODULE - NEWSLETTER MANAGER */}
            <Route
              path={routePath('user_module_newsletterManager_home')}
              exact
              element={<ModuleNewsletterManagerHomeScreen />}
            />

            {/* MODULE - LAW FINDER */}
            <Route
              path={routePath('user_module_lawFinder_home')}
              element={<ModuleLawFinderHomeScreen />}
            />

            {/* MODULE - RESOURCE MANAGER */}
            <Route
              path={routePath('user_module_resourceManager_resource_home')}
              element={<ModuleResourceManagerResourceHomeScreen />}
            />
            <Route
              path={routePath('user_module_resourceManager_obligation_home')}
              element={<ModuleResourceManagerObligationHomeScreen />}
            />
            <Route
              path={routePath('user_module_resourceManager_calendar')}
              element={<ModuleResourceManagerCalendarScreen />}
            />
            <Route
              path={routePath(
                'user_module_resourceManager_settings_resourceTemplate_list',
              )}
              element={<ModuleResourceManagerSettingsResourceTemplateListScreen />}
            />
            <Route
              path={routePath(
                'user_module_resourceManager_settings_resourceTemplate_add',
              )}
              element={<ModuleResourceManagerSettingsResourceAddScreen />}
            />
            <Route
              path={routePath(
                'user_module_resourceManager_settings_resourceTemplate_clone',
              )}
              element={<ModuleResourceManagerSettingsResourceTemplateCloneScreen />}
            />
            <Route
              path={routePath(
                'user_module_resourceManager_settings_internalObligations',
              )}
              element={<ModuleResourceManagerSettingsInternalObligationsScreen />}
            />
            <Route
              path={routePath(
                'user_module_resourceManager_settings_internalObligation_home',
              )}
              element={<ModuleResourceManagerSettingsInternalObligationHomeScreen />}
            />

            {/* MODULE - RISK MANAGER */}
            <Route
              path={routePath('user_module_inecoRiskManager_risk_list')}
              element={<ModuleInecoRiskManagerRiskListScreen />}
            />
            <Route
              path={routePath('user_module_inecoRiskManager_risk_add')}
              element={<ModuleInecoRiskManagerRiskHomeScreen />}
            />
            <Route
              path={routePath('user_module_inecoRiskManager_risk_home')}
              element={<ModuleInecoRiskManagerRiskHomeScreen />}
            />
            <Route
              path={routePath('user_module_inecoRiskManager_milestone_list')}
              element={<ModuleInecoRiskManagerMilestoneScreen />}
            />

            {/* MODULE - DOCUMENT MANAGER */}
            <Route
              path={routePath('user_module_documentManager_item_list')}
              element={<ModuleDocumentManagerItemListScreen />}
            />
            <Route
              path={routePath('user_module_documentManager_pendingItem_list')}
              element={<ModuleDocumentManagerPendingItemListScreen />}
            />
            <Route
              path={routePath('user_module_documentManager_tag_list')}
              element={<ModuleDocumentManagerTagListScreen />}
            />
            <Route
              path={routePath('user_module_documentManager_log_list')}
              element={<ModuleDocumentManagerLogListScreen />}
            />
            <Route
              path={routePath('user_module_documentManager_cover_redirect')}
              element={<ModuleDocumentManagerCoverRedirectScreen />}
            />
            <Route
              path={routePath('user_module_documentManager_cover')}
              element={<ModuleDocumentManagerCoverScreen />}
            />

            {/* MODULE - TOTAL ENERGIES RISK */}
            <Route
              path={routePath('user_module_totalEnergiesRisk_risk_list')}
              element={<ModuleTotalEnergiesRiskRiskListScreen />}
            />
            <Route
              path={routePath('user_module_totalEnergiesRisk_risk_add')}
              element={<ModuleTotalEnergiesRiskRiskHomeScreen />}
            />
            <Route
              path={routePath('user_module_totalEnergiesRisk_risk_edit')}
              element={<ModuleTotalEnergiesRiskRiskHomeScreen />}
            />
            <Route
              path={routePath('user_module_totalEnergiesRisk_control_list')}
              element={<ModuleTotalEnergiesRiskControlListScreen />}
            />
            <Route
              path={routePath('user_module_totalEnergiesRisk_control_add')}
              element={<ModuleTotalEnergiesRiskControlHomeScreen />}
            />
            <Route
              path={routePath('user_module_totalEnergiesRisk_control_edit')}
              element={<ModuleTotalEnergiesRiskControlHomeScreen />}
            />
            <Route
              path={routePath('user_module_totalEnergiesRisk_control_review_edit')}
              element={<ModuleTotalEnergiesRiskControlReviewHomeScreen />}
            />
            <Route
              path={routePath('user_module_totalEnergiesRisk_actionPlan_list')}
              element={<ModuleTotalEnergiesRiskActionPlanListScreen />}
            />
            <Route
              path={routePath('user_module_totalEnergiesRisk_actionPlan_add')}
              element={<ModuleTotalEnergiesRiskActionPlanHomeScreen />}
            />
            <Route
              path={routePath('user_module_totalEnergiesRisk_actionPlan_edit')}
              element={<ModuleTotalEnergiesRiskActionPlanHomeScreen />}
            />
            <Route
              path={routePath('user_module_totalEnergiesRisk_actionPlan_review_edit')}
              element={<ModuleTotalEnergiesRiskActionPlanReviewHomeScreen />}
            />
            <Route
              path={routePath('user_module_totalEnergiesRisk_process_list')}
              element={<ModuleTotalEnergiesRiskProcessListScreen />}
            />
            <Route
              path={routePath('user_module_totalEnergiesRisk_log_list')}
              element={<ModuleTotalEnergiesRiskLogListScreen />}
            />

            {/* MODULE - ENVIRONMENTAL ASPECTS ASSESSMENT */}
            <Route
              path={routePath(
                'user_module_environmentalAspectsAssessment_assessment_current',
              )}
              element={<EnvironmentalAspectsAssessmentAssessmentCurrentScreen />}
            />
            <Route
              path={routePath(
                'user_module_environmentalAspectsAssessment_assessment_home',
              )}
              element={<EnvironmentalAspectsAssessmentAssessmentHomeScreen />}
            />
            <Route
              path={routePath(
                'user_module_environmentalAspectsAssessment_assessment_log_list',
              )}
              element={<EnvironmentalAspectsAssessmentAspectLogListScreen />}
            />
            <Route
              path={routePath(
                'user_module_environmentalAspectsAssessment_inspection_list',
              )}
              element={<EnvironmentalAspectsAssessmentInspectionListScreen />}
            />
            <Route
              path={routePath(
                'user_module_environmentalAspectsAssessment_inspection_home',
              )}
              element={<EnvironmentalAspectsAssessmentInspectionHomeScreen />}
            />
            {/* MODULE - ADVANCED SEARCH */}
            <Route
              path={routePath('user_module_advancedSearch_home')}
              element={<AdvancedSearchHomeScreen />}
            />
            {/* MODULE - SURVEY */}
            <Route
              path={routePath('user_module_survey_home')}
              element={<SurveyHomeScreen />}
            />
            {/* MODULE - DYNAMIC FORM */}
            <Route
              path={routePath('user_module_dynamicForm_home')}
              element={<DynamicFormHomeScreen />}
            />
            <Route
              path={routePath('user_module_dynamicForm_step')}
              element={<ModuleDynamicFormStepScreen />}
            />
            <Route
              path={routePath('user_module_dynamicForm_endConfirm')}
              element={<ModuleDynamicFormEndConfirmScreen />}
            />
            <Route
              path={routePath('user_module_dynamicForm_end')}
              element={<ModuleDynamicFormEndScreen />}
            />

            {/* MODULE - MODULE BRIDGE FOLDER */}
            <Route
              path={routePath('user_module_moduleBridgeFolder_home')}
              element={<ModuleBridgeFolderHomeScreen />}
            />
          </Route>

          {/* ERROR 404 */}
          <Route path="*" element={<NotFoundScreen />} />
        </Routes>
      </div>
    </Container>
  );
};

export default MainContainer;

const Container = styled.div`
  margin-left: ${(props) =>
    props.$noSidebar === false ? '0' : props.$expanded ? '185px' : '35px'};
  transition: margin-left ease 0.3s;
  background-color: #f4f6f9;
  min-height: 100vh;
`;
